import React from "react";
import { services, bpoOfferings } from "../mock";
import { Users, GraduationCap, BookOpen, Headphones, ArrowUpRight, PhoneCall, Database, MessageSquare, Mic } from "lucide-react";
import { Button } from "./ui/button";

const iconMap = { Users, GraduationCap, BookOpen, Headphones };
const bpoIcons = [PhoneCall, Mic, Database, MessageSquare];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <div className="section-label justify-center mb-4">Our Services</div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-gray-900 spaced-heading">
            Driving <span className="text-brand">Career Success</span>
          </h2>
          <p className="mt-4 text-gray-600">Expert solutions for talent, training, career growth, and BPO operations.</p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, idx) => {
            const Icon = iconMap[s.icon] || Users;
            return (
              <div key={s.id} className="card-hover group relative bg-white border border-gray-100 rounded-2xl p-7 hover:border-brand">
                <div className="w-14 h-14 rounded-xl bg-brand-light flex items-center justify-center text-brand group-hover:bg-brand group-hover:text-white transition-colors">
                  <Icon size={26} />
                </div>
                <div className="absolute top-6 right-6 text-gray-200 font-display text-4xl font-bold">0{idx + 1}</div>
                <h3 className="mt-6 font-display text-xl font-bold text-gray-900 leading-snug">{s.title}</h3>
                <p className="mt-3 text-sm text-gray-600 leading-relaxed">{s.description}</p>
                <a href="#contact" className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-brand group/link">
                  Learn more <ArrowUpRight size={16} className="group-hover/link:translate-x-1 group-hover/link:-translate-y-1 transition-transform" />
                </a>
              </div>
            );
          })}
        </div>

        {/* BPO Solutions Deep-dive */}
        <div className="mt-24 relative rounded-3xl overflow-hidden">
          <div className="absolute inset-0 bg-brand" />
          <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(#fff 1px, transparent 1px)", backgroundSize: "20px 20px" }} />
          <div className="relative p-10 lg:p-16 text-white">
            <div className="grid lg:grid-cols-2 gap-10 items-start">
              <div>
                <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-1.5 text-xs uppercase tracking-widest font-semibold">
                  <Headphones size={14} /> New Offering
                </div>
                <h3 className="mt-5 font-display text-3xl md:text-5xl font-bold spaced-heading leading-tight">
                  We Offer BPO Solutions to Clients
                </h3>
                <p className="mt-5 text-white/85 leading-relaxed max-w-lg">
                  From inbound and outbound call centers to complete back-office operations, Lead Matrix delivers scalable BPO services that drive efficiency, reduce costs, and enhance customer experience.
                </p>
                <Button asChild className="mt-8 bg-white text-brand hover:bg-white/90 rounded-full h-12 px-7 font-semibold">
                  <a href="#contact">Discuss Your BPO Needs</a>
                </Button>
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                {bpoOfferings.map((b, i) => {
                  const Icon = bpoIcons[i];
                  return (
                    <div key={b.id} className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 hover:bg-white/20 transition-colors">
                      <div className="w-11 h-11 rounded-lg bg-white text-brand flex items-center justify-center mb-3">
                        <Icon size={20} />
                      </div>
                      <div className="font-bold text-white">{b.title}</div>
                      <div className="mt-1 text-sm text-white/80 leading-relaxed">{b.desc}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
